<template>

    <div v-show="abTestsLoaded">

        <link href="https://www.cleanfox.io" rel="canonical"/>

        <div v-if="isMaintenance" class="landing-maintenance">

            <span class="landing-maintenance-text">{{ $t('maintenance_title') }} {{ $t('maintenance_text_return') }} {{ $t('maintenance_text_thanks') }}</span>

        </div>

        <header class="landingv4__header-container">

            <img :src="computedLogo" alt="cleanfox logo" class="landingv4__header-logo">

        </header>

        <main class="noselect">

            <article1-mobile-default v-show="showArticle1MobileDefault" :requesting="requesting"
                                     @goLogin="goLogin"></article1-mobile-default>

            <article1-desktop-default v-show="showArticle1DesktopDefault" :requesting="requesting"
                                      @goLogin="goLogin"></article1-desktop-default>

            <article1-desktop-without-q-r-code v-show="showArticle1DesktopWithoutQRCode" :requesting="requesting"
                                               @goLogin="goLogin"></article1-desktop-without-q-r-code>

            <article class="article2__container">

                <h2 class="article2__title">{{ $t('landing_consent_press') }}</h2>

                <div class="article2__logo-container">

                    <a v-for="article in articles"
                       :href="article.href"
                       class="article2__a"
                       target="_blank"
                       rel="noopener noreferrer nofollow">
                        <img v-lazy="lazy(article.logo)" :alt="article.alt" class="article2__logo"/>
                    </a>

                </div>

            </article>

            <article class="article3__container">

                <h2 class="article3__title">{{ $t('landing_consent_tuto_title') }}</h2>

                <div class="article3__card-container">

                    <div class="article3__card">

                        <div class="article3__card-bubble">1</div>

                        <img v-lazy="lazy('/img/landing/v4/mailbox-full.svg')" alt="mailbox full" class="article3__card-image">

                        <p class="article3__card-text">{{ $t('landing_consent_tuto_1') }}</p>

                    </div>

                    <div v-if="isDesktop" class="article3__arrow-container">

                        <img v-lazy="lazy('/img/landing/v4/arrow-1.svg')" alt="arrow decoration" class="article3__arrow">

                    </div>

                    <div class="article3__card">

                        <div class="article3__card-bubble">2</div>

                        <img v-lazy="lazy('/img/landing/v4/newsletters-list.svg')" alt="newsletters list" class="article3__card-image">

                        <p class="article3__card-text">{{ $t('landing_consent_tuto_2') }}</p>

                    </div>

                    <div v-if="isDesktop" class="article3__arrow-container">

                        <img v-lazy="lazy('/img/landing/v4/arrow-2.svg')" alt="arrow decoration" class="article3__arrow">

                    </div>

                    <div class="article3__card">

                        <div class="article3__card-bubble">3</div>

                        <img v-lazy="lazy('/img/landing/v4/mailbox-night.svg')" alt="mailbox night"
                             class="article3__card-image">

                        <p class="article3__card-text">{{ $t('landing_consent_tuto_3') }}</p>

                    </div>


                </div>

            </article>

            <article id="privacy" class="article4__container">

                <h2 class="article4__title">{{ $t('your_data_title_page') }}</h2>

                <div class="article4__bloc-left">

                    <div class="article4__card">

                        <img alt="card gift" class="article4__card-img" src="/img/landing/card-gift.svg">

                        <span class="article4__card-text-container">

                                    <h2 class="article4__card-title">{{ $t('landing_consent_consent_title_1') }}</h2>

                                    <p class="article4__card-text">{{ $t('landing_consent_consent_description_1') }}</p>

                                </span>

                    </div>

                    <div class="article4__card">

                        <img alt="card secu" class="article4__card-img" src="/img/landing/card-secu.svg">

                        <span class="article4__card-text-container">

                                    <h2 class="article4__card-title">{{ $t('landing_consent_consent_title_2') }}</h2>

                                    <p class="article4__card-text">{{ $t('landing_consent_consent_description_2') }}</p>

                                </span>

                    </div>

                    <div class="article4__card">

                        <img alt="card safe" class="article4__card-img" src="/img/landing/card-safe.svg">

                        <span class="article4__card-text-container">

                                    <h2 class="article4__card-title">{{ $t('landing_consent_consent_title_3') }}</h2>

                                    <p class="article4__card-text">{{ $t('landing_consent_consent_description_3') }}</p>

                                </span>

                    </div>

                </div>

                <a :href="makeHref('/privacy.html')" class="btn btn-blue article4__btn" target="_blank" rel="noopener noreferrer nofollow">{{ $t('more_title') }}</a>

            </article>

            <article v-if="isDesktop && versionWithNativeAppRedirection" class="article5__container">

                <h2 class="article5__title">{{ $t('landing_consent_app_title') }}</h2>

                <p class="article5__subtitle">{{ $t('landing_consent_app_subtitle') }}</p>

                <div class="article5__badge-container">

                    <a :href="appleStoreRedirect" target="_blank" rel="noopener noreferrer nofollow" @click="clickPhoneV4">

                        <img v-lazy="lazy('/img/landing/appstore.svg')" alt="appstore" class="article5__badge">

                    </a>

                    <a href="https://app.adjust.com/uez2im" target="_blank" rel="noopener noreferrer nofollow" @click="clickPhoneV4">

                        <img v-lazy="lazy('/img/landing/playstore.png')" alt="playstore" class="article5__badge">

                    </a>

                </div>

                <div class="article5__phone-container">

                    <img class="article5__phone" :src="picturePhoneUrl">

                </div>

                <img v-lazy="lazy('/img/landing/v4/background-wave.svg')" alt="background wave" class="article5__wave">

            </article>

            <article class="more_qr" v-show="isDesktop && versionWithNativeAppRedirection">

                <span>{{ $t('generic_or') }}</span>

                <p>{{ $t('test_in_one_click') }}</p>

                <div class="context">
                    <div>
                        <img src="/img/icons/check-circle-green.svg">
                        <span>{{ $t('connect_more_easily') }}</span>
                    </div>
                    <div>
                        <img src="/img/icons/check-circle-green.svg">
                        <span>{{ $t('landing_test_app_quickly') }}</span>
                    </div>
                    <div>
                        <img src="/img/icons/check-circle-green.svg">
                        <span>{{ $t('landing_no_install') }}</span>
                    </div>
                </div>

                <div class="codes">
                    <div class="left">
                        <img src="/img/partner/qr-code-app-clip-1.svg">
                    </div>
                    <div class="right">
                        <q-r-code-instant-app></q-r-code-instant-app>
                    </div>
                </div>
            </article>

            <article class="article6__container">

                <h2 class="article6__title">{{ $t('landing_web_questions_title') }}</h2>

                <div class="article6__bloc-white-container">

                    <div class="article6__bloc-white">

                        <h3 class="article6__bloc-title">{{ $t('landing_web_questions_subtitle_clean') }}</h3>

                        <p class="article6__bloc-text">{{ $t('landing_web_questions_text_clean') }}</p>

                    </div>

                    <div class="article6__bloc-white">

                        <h3 class="article6__bloc-title">{{ $t('landing_web_questions_subtitle_mistake') }}</h3>

                        <p class="article6__bloc-text">{{ $t('landing_web_questions_text_mistake') }}</p>

                    </div>

                    <div class="article6__bloc-white">

                        <h3 class="article6__bloc-title">{{ $t('landing_web_questions_subtitle_forever') }}</h3>

                        <p class="article6__bloc-text">{{ $t('landing_web_questions_text_forever') }}</p>

                    </div>

                </div>


            </article>

            <article v-if="isDesktop" class="article7__container">

                <div class="article7__content">

                    <div class="article7__bloc">

                        <h2 class="article7__title">{{ $t('landing_consent_banner_title') }}</h2>

                        <p class="article7__subtitle">{{ $t('landing_consent_subtitle_description') }}</p>

                    </div>

                    <div class="article7__bloc">

                        <div class="article7__input-container" @click.self="focusInputV4">

                            <input ref="inputv4bottom" :placeholder="$t('landing_web_placeholder')"
                                   class="article7__input"
                                   v-on:keyup.enter="goLogin($refs.inputv4bottom.value, 'banner_cta')">

                            <a :href="makeHref('/login/email')" class="btn btn-green btn-big article7__button"
                               @click.prevent="goLogin($refs.inputv4bottom.value, 'banner_cta')">
                                <lottie-loader v-if="requesting" class="btn-loader"></lottie-loader>
                                <span :class="{ 'btn-hidden':  requesting}"
                                      class="article7__button-text">{{ $t('landing_consent_banner_cta') }}</span>
                            </a>

                            <img v-lazy="lazy('/img/partner/shine-white-right.svg')" alt="text decoration"
                                 class="article7__input-logo">

                        </div>

                    </div>

                </div>

            </article>

            <article class="article8__container">

                <h2 class="article8__title">Powered by</h2>

                <img v-lazy="lazy('/img/landing/niq-blue.svg')" alt="niq logo" class="article8__logo">

                <p class="article8__text">{{ $t('landing_consent_description_NielsenIQ') }}</p>

                <a class="btn article8__btn"
                   href="https://nielseniq.com/global/en/"
                   rel="noopener noreferrer nofollow"
                   target="_blank"
                   @click="clickNielsen">{{ $t('landing_consent_cta_NielsenIQ') }}</a>

            </article>

            <footer-fox></footer-fox>


        </main>

        <modal-error-provider ref="MEP" :email="emailError"></modal-error-provider>

<!--        <bottom-sheet-discovery-suggests ref="BSDS"></bottom-sheet-discovery-suggests>-->

        <toast ref="toast"></toast>

    </div>

</template>

<script>

import Vuex from 'vuex'

import Api from '../../api'
import {routerPushHelper} from '../../router'

import AbTest from '../../modules/abTest'
import I18n from '../../modules/i18n'
import UserFlow from '../../modules/userFlow'
import Tag from '../../modules/tag'
import Tracking from '../../modules/tracking'

import Article1DesktopDefault from '../../components/landing/Article1DesktopDefault'
import Article1MobileDefault from '../../components/landing/Article1MobileDefault'
import Article1DesktopWithoutQRCode from '../../components/landing/Article1DesktopWithoutQRCode'
// import BottomSheetDiscoverySuggests from '../../components/bottomSheet/BottomSheetDiscoverySuggests'
import Checkbox from '../../components/inputs/Checkbox'
import FooterFox from '../../components/footer/FooterFox'
import LottieLoader from '../../components/lottie/LottieLoader'
import Markdown from '../../components/Markdown'
import ModalErrorProvider from '../../components/modal/ModalErrorProvider'
import QRCodeInstantApp from '../../components/landing/QRCodeInstantApp'
import Toast from '../../components/Toast'

import Storage from '../../helpers/storage'

import ENUM from '../../assets/ENUM'


export default {

    name: 'landing',

    components: {
        // BottomSheetDiscoverySuggests,
        Article1DesktopDefault,
        Article1MobileDefault,
        Article1DesktopWithoutQRCode,
        Checkbox,
        FooterFox,
        LottieLoader,
        Markdown,
        ModalErrorProvider,
        QRCodeInstantApp,
        Toast
    },

    computed: {

        ...Vuex.mapGetters([
            'lang'
        ]),

        showArticle1MobileDefault() {
            return !this.isDesktop
        },
        showArticle1DesktopDefault() {
            return this.isDesktop && this.versionWithNativeAppRedirection
        },
        showArticle1DesktopWithoutQRCode() {
            return this.isDesktop && !this.versionWithNativeAppRedirection
        },

        computedLogo() {
            return this.isDesktop ? '/img/logo/large/white.svg' : '/img/logo/fox/blue-head-white.svg'
        },

        appleStoreRedirect() {
            return 'https://app.adjust.com/uez2im'
        },

        articles() {
            return I18n.is.french(this)
                ? this.i18nArticles.fr
                : this.i18nArticles.default

        },

        picturePhoneUrl() {
            const language = this.lang.split('-')[0]
            if (this.languagesWithPicturePhoneUrl.indexOf(language) > -1) {
                return `/img/landing/v4/phones/GetTheApp_illustration-2_${language}.png`
            } else {
                return '/img/landing/v4/phones/GetTheApp_illustration-2_en.png'
            }
        }

    },

    data() {

        return {
            // eslint-disable-next-line no-useless-escape
            regexMail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            emailError: '',
            isMaintenance: false,
            requesting: false,
            abTestsLoaded: false,
            i18nArticles: {
                // eslint-disable-next-line id-length
                fr: [
                    {
                        href: 'https://www.maddyness.com/2016/09/16/startups-cleanfox-ecoclicot-je-suis-nul-en-informatique-ineoco-archive-valley/',
                        logo: '/img/landing/logos/fr/v4/logo1.svg',
                        alt: 'maddyness article'
                    },
                    {
                        href: 'https://www.bfmtv.com/economie/replay-emissions/tech-and-co/tech-for-good-awards-cleanfox-propose-un-outil-pour-faire-le-menage-dans-sa-boite-mail-et-limiter-la-pollution-numerique-04-11_VN-202011040368.html',
                        logo: '/img/landing/logos/fr/v4/logo2.svg',
                        alt: 'bfmtv article'
                    },
                    {
                        href: 'https://rmc.bfmtv.com/mediaplayer/video/j-ai-teste-pour-vous-cleanfox-le-nettoyeur-de-boites-mail-1117097.html',
                        logo: '/img/landing/logos/fr/v4/logo3.svg',
                        alt: 'rmc article'
                    },
                    {
                        href: 'https://www.lemonde.fr/m-perso/article/2020/01/11/trois-applis-pour-dire-stop-en-2020_6025544_4497916.html',
                        logo: '/img/landing/logos/fr/v4/logo4.svg',
                        alt: 'lemonde article'
                    },
                    {
                        href: 'https://www.tf1info.fr/societe/environnement-google-5-gestes-simples-pour-reduire-votre-pollution-sur-internet-web-ordinateur-mail-recherche-pj-2076788.html',
                        logo: '/img/landing/logos/fr/v4/logo5.svg',
                        alt: 'tf1info article'
                    },
                    {
                        href: 'https://www.journaldugeek.com/2019/07/31/cleanfox-la-solution-magique-pour-nettoyer-votre-boite-mail-en-faisant-du-bien-a-la-planete/',
                        logo: '/img/landing/logos/fr/v4/logo6.svg',
                        alt: 'journaldugeek article'
                    },
                    {
                        href: 'https://www.francetvinfo.fr/sante/maladie/coronavirus/nouveau-monde-nettoyer-sa-boite-mail-pendant-le-confinement_3913865.html',
                        logo: '/img/landing/logos/fr/v4/logo7.svg',
                        alt: 'francetvinfo article'
                    },
                    {
                        href: 'https://www.gqmagazine.fr/lifestyle/article/10-applications-pour-minimiser-son-empreinte-carbone',
                        logo: '/img/landing/logos/fr/v4/logo8.svg',
                        alt: 'gqmagazine article'
                    }
                ],
                default: [
                    {
                        href: 'https://fr.news.yahoo.com/mails-petit-geste-écologique-trie-122021539.html',
                        logo: '/img/landing/logos/en/yahoo.svg',
                        alt: 'yahoo article'
                    },
                    {
                        href: 'https://www.gqmagazine.fr/lifestyle/article/10-applications-pour-minimiser-son-empreinte-carbone',
                        logo: '/img/landing/logos/en/gq.svg',
                        alt: 'gq article'
                    },
                    {
                        href: 'https://www.siliconrepublic.com/enterprise/edouard-nattee-digital-pollution-data-climate-crisis',
                        logo: '/img/landing/logos/en/siliconrepublic.png',
                        alt: 'silicon republic article'
                    },
                    {
                        href: 'https://www.bbc.com/portuguese/vert-fut-52907152',
                        logo: '/img/landing/logos/en/bbc.svg',
                        alt: 'bbc article'
                    },
                    {
                        href: 'https://eu.usatoday.com/story/tech/columnist/2020/08/09/email-zoom-and-password-troubles-among-top-tech-support-issues/3305452001/',
                        logo: '/img/landing/logos/en/usa_today.svg',
                        alt: 'usa today article'
                    },
                    {
                        href: 'https://gmail.softonic.com/articulos/gmail-acabar-spam-para-siempre',
                        logo: '/img/landing/logos/en/softonic.svg',
                        alt: 'softtonic article'
                    },
                    {
                        href: 'https://metro.co.uk/2021/04/16/its-easy-being-green-recycling-tech-thatll-save-the-planet-14418228/',
                        logo: '/img/landing/logos/en/metro.svg',
                        alt: 'metro article'
                    },
                    {
                        href: 'https://www.euronews.com/green/2020/08/12/a-step-by-step-guide-eight-ways-to-make-sustainable-living-work-for-you',
                        logo: '/img/landing/logos/en/euronews.svg',
                        alt: 'euronews article'
                    }
                ]
            },
            languagesWithPicturePhoneUrl: ['ar', 'da', 'de', 'en', 'es', 'fr', 'hi', 'it', 'ja', 'ko', 'nl', 'pl', 'pt', 'sv'],
            versionWithNativeAppRedirection: true
        }
    },

    async created() {

        if (this.$route.path === '/start') {
            this.versionWithNativeAppRedirection = false
            this.saveVersion(ENUM.abTest.B)

            Tag.infoAmplitude(this, 'landing-version-marketing-without-qr-code')
        } else {
            let abTestVersion = Storage.getItem(ENUM.FIREBASE.LANDING_WITHOUT_QR_CODE)
            if (!abTestVersion) {
                abTestVersion = await AbTest.getInPercentage(ENUM.FIREBASE.LANDING_WITHOUT_QR_CODE)
            }
            this.saveVersion(abTestVersion)

            if(abTestVersion === ENUM.abTest.B) {
                Tag.infoAmplitude(this, 'landing-abtest-qr-code-version-B')
            } else {
                Tag.infoAmplitude(this, 'landing-abtest-qr-code-version-A')
            }
        }

    },

    mounted() {


        // save tracking before
        Tracking.saveTracking(this.$route.query)

        UserFlow.setPage(this, 'landing_web')

        if (this.$route.params && this.$route.params.error) {

            this.$refs.toast.open()

        }

        Api.server.healthCheck()
            .then(maintenance => {
                if (maintenance.status === 'maintenance') {
                    this.isMaintenance = true
                }
            })
            .catch(() => {
            })


        // Demo mode suspended for an indefinite period
        // if(!Storage.getItem(Storage.KEYS.IS_TUTO_DISCOVERY_DONE)) {
        //     this.$refs.BSDS.open()
        // }

    },

    methods: {

        lazy(url) {
            return {src: url}
        },

        clickPhoneV4() {
            Tag.clickGA(this, 'app_download')
        },

        focusInputV4() {
            this.$refs.inputv4.focus()
        },

        goLogin(email) {
            if (this.regexMail.test(email)) {
                Tag.clickGA(this, 'landing_validate')
                this.requesting = true
                UserFlow.getProvider(email)
                    .then(data => {
                        Tag.clickAmplitude(this, 'connect_email')

                        const path = UserFlow.getLoginPathUsingProviderAndInvalidGrant(data)
                        routerPushHelper(this.$router, path)
                    })
                    .catch(error => {
                        this.requesting = false
                        this.emailError = email
                        if (error.message === 'mx_unsupported' || error.message === 'mx_not_found') {

                            this.$refs.MEP.show(error)
                        } else {
                            this.$refs.toast.open()
                        }
                    })
            }
        },

        clickGA(event) {

            Tag.clickGA(this, event)

        },

        clickAmplitude(event) {

            Tag.clickAmplitude(this, event)

        },

        clickNielsen() {
            Tag.clickAmplitude(this, 'cta_nielsen')
        },

        saveVersion(abTestVersion) {
            Storage.setItem('landing_without_qr_code_web', abTestVersion)
            this.versionWithNativeAppRedirection = !(abTestVersion === ENUM.abTest.B)
            this.abTestsLoaded = true
        }

    }
}
</script>

<style lang="scss" scoped src="./style.scss"></style>

